let _ = t => t,
  _t;
import * as Operators from 'customer-data-filters-ui/filterQueryFormat/operator/Operators';
import { useGetOperators } from './useGetOperators';
import { useTranslationHelpers } from './useTranslationHelpers';
import { EQUATION, ROLLUP } from 'customer-data-objects/property/PropertyFieldTypes';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { Badge } from 'foundations-components/transitional/components/Badge';
import { useStrategy } from './useStrategy';
import { CrmSearch, InboundDbListSeg, SalesViews } from '../filterQueryFormat/strategy/StrategyTypes';
// @ts-expect-error Could not find a declaration file for module
import { EMAIL_CAMPAIGN } from 'reference-resolvers/constants/ReferenceObjectTypes';
import styledWithTheme from 'foundations-theming/utils';
import { jsx as _jsx } from "react/jsx-runtime";
export const operatorsWithPropertyHistoryRequirement = [Operators.EverContainedAll, Operators.EverContainedAny, Operators.EverEqual, Operators.EverEqualAny, Operators.EverIn, Operators.NeverContained, Operators.NeverContainedAll, Operators.NeverEqual, Operators.NeverEqualAny, Operators.NeverIn, Operators.NotUpdatedInLastXDays, Operators.UpdatedAfter, Operators.UpdatedBefore, Operators.UpdatedInLastXDays];
const operatorsWithNewBadgeCrmSearch = [];
const operatorsWithNewBadgeSalesViews = [];
const operatorsWithNewBadgeILS = [
/**
 * @temporary Natures first green is gold... Nothing gold can stay.
 * @expiration 2025-06-30
 * @deprecated
 */
Operators.InDynamicDateRange];

// This fixes Badge alignment inside a UITypeaheadResultsItem
const StyledBadgeContainer = styledWithTheme.span(_t || (_t = _`
  line-height: 18px;
  vertical-align: top !important;
`));
const shouldUseNewBadge = (Operator, strategyType) => {
  switch (strategyType) {
    case CrmSearch:
      return operatorsWithNewBadgeCrmSearch.includes(Operator);
    case SalesViews:
      return operatorsWithNewBadgeSalesViews.includes(Operator);
    case InboundDbListSeg:
      return operatorsWithNewBadgeILS.includes(Operator);
    default:
      return false;
  }
};
const getNewBadge = (Operator, field, strategyType) => {
  if (shouldUseNewBadge(Operator, strategyType)) {
    return /*#__PURE__*/_jsx(StyledBadgeContainer, {
      children: /*#__PURE__*/_jsx(Badge, {
        use: "new",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "newCustomerDataFilters.filterGroupEditor.newBadge"
        })
      })
    });
  }
  return null;
};
export const useOperatorOptions = (filterFamily, condition) => {
  var _condition$field;
  const {
    getOperators,
    getRefinementOperators
  } = useGetOperators();
  const {
    getOperatorLabelString
  } = useTranslationHelpers(filterFamily);
  const {
    strategyType
  } = useStrategy();
  const isFieldCalculatedProperty = [EQUATION, ROLLUP].includes((_condition$field = condition.field) === null || _condition$field === void 0 ? void 0 : _condition$field.fieldType);
  let operators = [];
  if (condition.field.refinement) {
    operators = getRefinementOperators(filterFamily, condition.field);
  } else {
    operators = getOperators(filterFamily, condition.field, condition);
  }
  const field = condition.field;
  const options = operators.map(Operator => {
    let tooltipMessage = /*#__PURE__*/_jsx(FormattedMessage, {
      message: "customerDataFiltersUI.customerDataFilters.FilterOperatorInput.tooltipOperatorNotSupported"
    });
    let isDisabled = isFieldCalculatedProperty && operatorsWithPropertyHistoryRequirement.includes(Operator);
    if (filterFamily === EMAIL_CAMPAIGN) {
      if (Operator === Operators.LessThanRolling || Operator === Operators.GreaterThanRolling) {
        isDisabled = true;
        tooltipMessage = /*#__PURE__*/_jsx(FormattedMessage, {
          message: "customerDataFiltersUI.customerDataFilters.FilterOperatorInput.currentlyDisabled"
        });
      }
    }
    if (Operator === Operators.InRange && (field === null || field === void 0 ? void 0 : field.type) === 'number' && (field === null || field === void 0 ? void 0 : field.numberDisplayHint) === 'percentage' && strategyType === InboundDbListSeg) {
      isDisabled = true;
      tooltipMessage = /*#__PURE__*/_jsx(FormattedMessage, {
        message: "customerDataFiltersUI.customerDataFilters.FilterOperatorInput.currentlyDisabled"
      });
    }
    return {
      value: Operator.toString(),
      text: getOperatorLabelString(Operator, field),
      badge: getNewBadge(Operator, field, strategyType),
      disabled: isDisabled,
      dropdownText: /*#__PURE__*/_jsx(Tooltip, {
        disabled: !isDisabled,
        title: isDisabled ? tooltipMessage : '',
        children: /*#__PURE__*/_jsx("span", {
          children: getOperatorLabelString(Operator, field)
        })
      })
    };
  }).toArray();
  const getOperatorByName = operatorName => {
    // @ts-expect-error ts-migrate(7006) FIXME: Parameter 'Operator' implicitly has an 'any' type.
    return operators.find(Operator => Operator.toString() === operatorName);
  };
  return {
    options,
    getOperatorByName
  };
};